import { trackView } from '../../../_common/client/tracking';
import { isFoldable } from './is-foldable';

export function initializeSubheading(rootElement: HTMLElement) {
    const subHeadingElement = rootElement.querySelector<HTMLElement>('.js_pdp_short-info__subheading');
    if (!subHeadingElement) return;
    trackView({ product_ShortInfo: isFoldable(subHeadingElement) ? ['foldable'] : ['not_foldable'] });
}
